import { isNull } from "/lib/html5-software-library/src/ranj/util/TypeUtil";
import NavigateEvent from "../../../core/navigation/NavigateEvent";
import SkinFactory from "../../../core/ui/SkinFactory";
import Problem from "../model/Problem";
import ProblemModel from "../model/ProblemModel";
import Solution from "../model/Solution";
import ProblemLinkingFeedbackHelper from "./ProblemLinkingFeedbackHelper";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";

/**
* ProblemLinkingFeedbackCommand.js
* 
* Created on 4-nov-2013
*
* @author Olivier van der Pool for Ranj
**/
export default class ProblemLinkingFeedbackCommand {
    constructor(dispatcher) {
        this._dispatcher = dispatcher;

        this.execute = function({ params }) {
            const correctModel = params.correctModel;
            const selectedSolution = params.selectedSolution;
            const problem = params.problem;
            const selectedArguments = params.selectedArguments;

            const playerModel = this._buildPlayerModel(correctModel, selectedSolution, problem, selectedArguments);
            const feedbackHelper = new ProblemLinkingFeedbackHelper();

            const onSolutionFeedback = (result, playerSolution, correctSolution, problem) => {
                if (result) {
                    //handle score for correct solution
                    console.log(`[ProblemLinkingFeedbackCommand] The player chose the correct solution for problem '${problem.getID()}'.`);
                } else {
                    console.log(`[ProblemLinkingFeedbackCommand] The player chose the incorrect solution for problem '${problem.getID()}'.`);
                }
            };

            const onArgumentFeedback = (result, argument, problem) => {
                if (result) {
                    //handle score for correct argument
                    console.log(`[ProblemLinkingFeedbackCommand] The player correctly supported the solution for problem '${problem.getID()}' with argument '${argument.getID()}'.`);
                } else {
                    console.log(`[ProblemLinkingFeedbackCommand] The player incorrectly supported the solution for problem '${problem.getID()}' with argument '${argument.getID()}'.`);
                }
            };

            const onMissingArgument = (argument, problem) => {
                console.log(`[ProblemLinkingFeedbackCommand] Missing argument '${argument.getID()}' for problem '${problem.getID()}'.`);
            };

            feedbackHelper.handleFeedback(playerModel, correctModel, onSolutionFeedback, onArgumentFeedback, onMissingArgument);

            const skin = SkinFactory.getSkin(SkinKeyRegistry.PROBLEM_LINKING_FEEDBACK_SCREEN_SKIN);
            skin.playerModel = playerModel;
            const commandEvent = new NavigateEvent(NavigateEvent.GOTO_SCREEN_REQUEST, null, skin);

            this._dispatcher.dispatch(commandEvent.type, { data: commandEvent });

        };
    }

    _buildPlayerModel(correctModel, selectedSolution, currentProblem, selectedArguments) {
        //creates a problem model containing the user input
        const model = new ProblemModel();
        const problem = new Problem();
        const solution = new Solution();
        problem.setID(currentProblem.getID());
        solution.setID(selectedSolution);

        //put the selected arguments in an array;
        for (let i = 0; i < selectedArguments.length; i++) {
            if (!isNull(selectedArguments[i])) {
                const argument = correctModel.getPossibleArgumentByID(selectedArguments[i]);
                argument.buttonIndex = i + 1; //save in which button slot the argument is located
                solution.addArgument(argument);
            }
        }

        problem.addSolution(solution);
        model.addProblem(problem);

        return model;
    }
}

